import Extend from 'flarum/common/extenders';

export default [
  // Add your common extenders here
];
